// Trend Extension indicator next to the conjugacy badge: two triangles pointing the
// first breakout's side. Grey while counting (w1-w3), yellow at candidate, the
// side's own colour once in play. No count, no badge.
const PHASE_COLOR = { wave1: 'text-gray-400', wave2: 'text-gray-400', wave3: 'text-gray-400', candidate: 'text-yellow-400' };
const PHASE_TITLE = { wave1: 'w1', wave2: 'w2', wave3: 'w3', candidate: 'candidate', in_play: 'in play' };

export const trendExtensionView = (state) => {
  let phase = 'reset';
  if (state?.in_play) phase = 'in_play';
  else if (state?.coupled) phase = 'wave1';
  else if (state?.wave === 4) phase = 'candidate';
  else if (state?.wave === 2 || state?.wave === 3) phase = `wave${state.wave}`;
  return { phase, side: state?.first_side };
};

export const trendExtensionBadgeLook = (phase, side) => {
  if (!PHASE_TITLE[phase]) return null;
  const s = (side || '').toLowerCase();
  // An unknown TE side has no direction to point — a neutral diamond.
  const glyph = s === 'buy' ? '▲▲' : s === 'sell' ? '▼▼' : '◆◆';
  const color = PHASE_COLOR[phase]
    || (s === 'buy' ? 'text-emerald-600' : s === 'sell' ? 'text-red-500' : 'text-gray-400');
  return { glyph, color, title: `Trend Extension: ${PHASE_TITLE[phase]}` };
};

const TrendExtensionBadge = ({ phase, side }) => {
  const look = trendExtensionBadgeLook(phase, side);
  if (!look) return null;
  return (
    // Same tile as InfluenceArrowsBadge, so the two read as a pair.
    <span
      className="inline-flex items-center gap-0.5 rounded-md border border-olive-200 bg-white/70 px-1.5 py-0.5 leading-none"
      title={look.title}
    >
      {[...look.glyph].map((g, i) => (
        <span key={i} className={`text-[13px] ${look.color}`}>{g}</span>
      ))}
    </span>
  );
};

export default TrendExtensionBadge;
